import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { motion } from 'framer-motion'
import { ReactComponent as RemoveIcon } from '../images/icons/remove.svg'
import { SelectInput } from '@demandlocal/components'

const SelectedAccountsOptionsList = ({
  vendor_id,
  watchKey,
}: {
  vendor_id: number
  watchKey?: string
}): JSX.Element => {
  const { watch, getValues, control, setValue } = useFormContext()

  const key = watchKey ?? `vendors.${vendor_id}`

  const values = watch(key)
  console.log(values)

  useEffect(() => {
    // check if all values have push_frequency
    const valuesHavePushFrequency = values?.every(
      (v: { push_frequency: string }) => v.push_frequency,
    )
    if (!valuesHavePushFrequency) {
      values?.forEach(
        (value: {
          value: string
          push_frequency: { label: string; value: string } | undefined
        }) => {
          if (value.push_frequency) return
          setValue(`${key}.${values.indexOf(value)}.push_frequency`, {
            label: 'Daily',
            value: 'daily',
          })
        },
      )
    }
  }, [key, setValue, values])

  return (
    <>
      {values?.length > 0 && (
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          className={'flex flex-row flex-1 flex-wrap justify-start items-end gap-3'}>
          {values?.map((value: { value: string; label: string }, index: number) => {
            return (
              <div
                key={value.value}
                className={
                  'flex flex-col p-2 bg-white border-2 min-w-32 rounded-lg min-w-[120px]'
                }>
                <div className={'flex justify-between text-xs'}>
                  <span className={'font-bold'}>{value.label}</span>
                  <RemoveIcon
                    className={'cursor-pointer ml-2'}
                    onClick={(e) => {
                      e.preventDefault()
                      setValue(
                        `vendor_${vendor_id}`,
                        getValues(`vendor_${vendor_id}`).filter(
                          (v: { value: string }) => v.value !== value.value,
                        ),
                      )
                    }}
                  />
                </div>
                <span className={'font-medium pt-1 text-xs'}>{value.value}</span>
                <div className={'mt-2 border-t-2 pt-2'}>
                  <SelectInput
                    name={`${key}.${index}.push_frequency`}
                    label={'Push Frequency'}
                    options={[
                      {
                        label: 'Daily',
                        value: 'daily',
                      },
                      {
                        label: 'One time',
                        value: 'one_time',
                      },
                    ]}
                  />
                </div>
              </div>
            )
          })}
        </motion.div>
      )}
    </>
  )
}

export default SelectedAccountsOptionsList
